export const MODELS_PANEL_STATE = {
  DEFAULT: "DEFAULT",
  CREATE_GROUP: "CREATE_GROUP",
  EDIT_GROUP: "EDIT_GROUP",
  ADD_TO_GROUP: "ADD_TO_GROUP",
}
